const openModal = document.querySelectorAll("[data-modal-id]");
const modal = document.querySelectorAll(".modal");
const body = document.body;

openModal.forEach((e) => {
    //open modal by id
    const modalId = document.querySelector("#" + e.dataset.modalId);
    e.addEventListener("click", () => {
        modalId.showModal();
        modalId.setAttribute("aria-modal", "true")
        body.classList.add("modal-overflow");

        const modalBody = modalId.querySelector(".modal-body");
        modalBody.scrollTop = 0;

        if(modalId.matches("[data-modal='video']") || modalId.matches("[data-modal='video-small']")) {
            modalId.querySelector("video").play();
        }
    });
});

modal.forEach((e) => {
    //close modal on button
    const closeBtn = e.querySelector("[data-modal='close']");
    closeBtn.addEventListener("click", () => {
        body.classList.remove("modal-overflow");
        closeModal(e);
    });


    document.onkeyup = function (event) {
        if (event.keyCode === 27) {
            body.classList.remove("modal-overflow");
        }
    }

    //close modal on modalBody
    const modalBody = e.querySelector(".modal-body");
    modalBody.addEventListener("click", (a) => {
        if (a.target == modalBody) {
            body.classList.remove("modal-overflow");
            closeModal(e);
        }
    });
});

const closeModal = (e) => {
    //close modal function
    e.setAttribute("closing", "");
    e.setAttribute("aria-modal", "false");
    e.addEventListener(
        "animationend",
        () => {
            e.removeAttribute("closing");
            e.close();
        },
        { once: true }
    );

    const iframe = e.querySelector("iframe");
    if (iframe) {
        const src = iframe.src;
        iframe.src = "";
        const noAutoplaySrc = src.replace("&autoplay=1", "").replace("?autoplay=1", "");
        iframe.src = noAutoplaySrc;
    }
    
    //Modal Video Stop
    if (e.matches("[data-modal='video']") || e.matches("[data-modal='video-small']")) {
        e.querySelector("video").pause();
    }
};